import { render } from "./GlossaryPage.vue?vue&type=template&id=0b92ebf2"
import script from "./GlossaryPage.vue?vue&type=script&lang=js"
export * from "./GlossaryPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__